/* ── Shared Geo Data & Types ─────────────────────────────── */

export interface GeoCountry {
  id?: number;
  code: string;
  name: string;
  currency: string;
  phoneCode?: string;
  flagUrl?: string;
  active?: boolean;
  rideServiceEnabled?: boolean;
}

export interface GeoState {
  id?: number;
  backendId?: number;
  code: string;
  name: string;
  countryCode: string;
  active?: boolean;
}

export interface GeoCity {
  id: number;
  backendId?: number;
  name: string;
  stateCode: string;
  countryCode: string;
  stateId?: number;
  latitude?: number;
  longitude?: number;
  active?: boolean;
}

export const GEO_COUNTRIES: GeoCountry[] = [
  { code: 'US', name: 'United States', currency: 'USD' },
  { code: 'CA', name: 'Canada',        currency: 'CAD' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP' },
  { code: 'AU', name: 'Australia',      currency: 'AUD' },
  { code: 'AE', name: 'UAE',            currency: 'AED' },
  { code: 'SA', name: 'Saudi Arabia',   currency: 'SAR' },
  { code: 'MX', name: 'Mexico',         currency: 'MXN' },
  { code: 'BR', name: 'Brazil',         currency: 'BRL' },
  { code: 'AR', name: 'Argentina',      currency: 'ARS' },
  { code: 'CO', name: 'Colombia',       currency: 'COP' },
  { code: 'CL', name: 'Chile',          currency: 'CLP' },
  { code: 'DE', name: 'Germany',        currency: 'EUR' },
  { code: 'FR', name: 'France',         currency: 'EUR' },
  { code: 'IT', name: 'Italy',          currency: 'EUR' },
  { code: 'ES', name: 'Spain',          currency: 'EUR' },
  { code: 'TR', name: 'Turkey',         currency: 'TRY' },
  { code: 'NG', name: 'Nigeria',        currency: 'NGN' },
  { code: 'ZA', name: 'South Africa',   currency: 'ZAR' },
  { code: 'EG', name: 'Egypt',          currency: 'EGP' },
  { code: 'KE', name: 'Kenya',          currency: 'KES' },
];

export const GEO_STATES: GeoState[] = [
  { code: 'NY',  name: 'New York',         countryCode: 'US' },
  { code: 'CA',  name: 'California',       countryCode: 'US' },
  { code: 'TX',  name: 'Texas',            countryCode: 'US' },
  { code: 'FL',  name: 'Florida',          countryCode: 'US' },
  { code: 'IL',  name: 'Illinois',         countryCode: 'US' },
  { code: 'AZ',  name: 'Arizona',          countryCode: 'US' },
  { code: 'ON',  name: 'Ontario',          countryCode: 'CA' },
  { code: 'BC',  name: 'British Columbia', countryCode: 'CA' },
  { code: 'QC',  name: 'Quebec',           countryCode: 'CA' },
  { code: 'ENG', name: 'England',          countryCode: 'GB' },
  { code: 'SCO', name: 'Scotland',         countryCode: 'GB' },
  { code: 'NSW', name: 'New South Wales',  countryCode: 'AU' },
  { code: 'VIC', name: 'Victoria',         countryCode: 'AU' },
  { code: 'DXB', name: 'Dubai',            countryCode: 'AE' },
  { code: 'AUH', name: 'Abu Dhabi',        countryCode: 'AE' },
  { code: 'RIY', name: 'Riyadh Province',   countryCode: 'SA' },
  { code: 'MKH', name: 'Makkah',           countryCode: 'SA' },
  { code: 'EP',  name: 'Eastern Province', countryCode: 'SA' },
  { code: 'CMX', name: 'Mexico City',      countryCode: 'MX' },
  { code: 'JAL', name: 'Jalisco',          countryCode: 'MX' },
  { code: 'NLE', name: 'Nuevo León',       countryCode: 'MX' },
  { code: 'SP',  name: 'São Paulo',        countryCode: 'BR' },
  { code: 'RJ',  name: 'Rio de Janeiro',   countryCode: 'BR' },
  { code: 'BA',  name: 'Buenos Aires',     countryCode: 'AR' },
  { code: 'CUN', name: 'Cundinamarca',     countryCode: 'CO' },
  { code: 'ANT', name: 'Antioquia',        countryCode: 'CO' },
  { code: 'RM',  name: 'Región Metropolitana', countryCode: 'CL' },
  { code: 'BY',  name: 'Bavaria',            countryCode: 'DE' },
  { code: 'BE',  name: 'Berlin',             countryCode: 'DE' },
  { code: 'NW',  name: 'North Rhine-Westphalia', countryCode: 'DE' },
  { code: 'HH',  name: 'Hamburg',            countryCode: 'DE' },
  { code: 'IDF', name: 'Île-de-France',      countryCode: 'FR' },
  { code: 'PAC', name: 'Provence-Alpes-Côte d\'Azur', countryCode: 'FR' },
  { code: 'ARA', name: 'Auvergne-Rhône-Alpes', countryCode: 'FR' },
  { code: 'LA',  name: 'Lagos',              countryCode: 'NG' },
  { code: 'AB',  name: 'Abuja',              countryCode: 'NG' },
  { code: 'GP',  name: 'Gauteng',            countryCode: 'ZA' },
  { code: 'WC',  name: 'Western Cape',       countryCode: 'ZA' },
  { code: 'CAI', name: 'Cairo Governorate',  countryCode: 'EG' },
  { code: 'NBO', name: 'Nairobi County',     countryCode: 'KE' },
  { code: 'LOM', name: 'Lombardy',           countryCode: 'IT' },
  { code: 'LAZ', name: 'Lazio',              countryCode: 'IT' },
  { code: 'MAD', name: 'Madrid',             countryCode: 'ES' },
  { code: 'CAT', name: 'Catalonia',          countryCode: 'ES' },
  { code: 'IST', name: 'Istanbul',           countryCode: 'TR' },
  { code: 'ANK', name: 'Ankara',             countryCode: 'TR' },
];

export const GEO_CITIES: GeoCity[] = [
  { id: 1,  name: 'New York City',  stateCode: 'NY',  countryCode: 'US' },
  { id: 2,  name: 'Buffalo',        stateCode: 'NY',  countryCode: 'US' },
  { id: 3,  name: 'Los Angeles',    stateCode: 'CA',  countryCode: 'US' },
  { id: 4,  name: 'San Francisco',  stateCode: 'CA',  countryCode: 'US' },
  { id: 5,  name: 'San Diego',      stateCode: 'CA',  countryCode: 'US' },
  { id: 6,  name: 'Houston',        stateCode: 'TX',  countryCode: 'US' },
  { id: 7,  name: 'Dallas',         stateCode: 'TX',  countryCode: 'US' },
  { id: 8,  name: 'Miami',          stateCode: 'FL',  countryCode: 'US' },
  { id: 9,  name: 'Orlando',        stateCode: 'FL',  countryCode: 'US' },
  { id: 10, name: 'Chicago',        stateCode: 'IL',  countryCode: 'US' },
  { id: 11, name: 'Phoenix',        stateCode: 'AZ',  countryCode: 'US' },
  { id: 12, name: 'Toronto',        stateCode: 'ON',  countryCode: 'CA' },
  { id: 13, name: 'Ottawa',         stateCode: 'ON',  countryCode: 'CA' },
  { id: 14, name: 'Vancouver',      stateCode: 'BC',  countryCode: 'CA' },
  { id: 15, name: 'Montreal',       stateCode: 'QC',  countryCode: 'CA' },
  { id: 16, name: 'London',         stateCode: 'ENG', countryCode: 'GB' },
  { id: 17, name: 'Manchester',     stateCode: 'ENG', countryCode: 'GB' },
  { id: 18, name: 'Edinburgh',      stateCode: 'SCO', countryCode: 'GB' },
  { id: 19, name: 'Sydney',         stateCode: 'NSW', countryCode: 'AU' },
  { id: 20, name: 'Melbourne',      stateCode: 'VIC', countryCode: 'AU' },
  { id: 21, name: 'Dubai City',     stateCode: 'DXB', countryCode: 'AE' },
  { id: 22, name: 'Abu Dhabi City', stateCode: 'AUH', countryCode: 'AE' },
  { id: 23, name: 'Riyadh City',    stateCode: 'RIY', countryCode: 'SA' },
  { id: 32, name: 'Jeddah',         stateCode: 'MKH', countryCode: 'SA' },
  { id: 33, name: 'Makkah',         stateCode: 'MKH', countryCode: 'SA' },
  { id: 34, name: 'Dammam',         stateCode: 'EP',  countryCode: 'SA' },
  { id: 35, name: 'Dhahran',        stateCode: 'EP',  countryCode: 'SA' },
  { id: 24, name: 'Mexico City',    stateCode: 'CMX', countryCode: 'MX' },
  { id: 36, name: 'Guadalajara',    stateCode: 'JAL', countryCode: 'MX' },
  { id: 37, name: 'Zapopan',        stateCode: 'JAL', countryCode: 'MX' },
  { id: 38, name: 'Monterrey',      stateCode: 'NLE', countryCode: 'MX' },
  { id: 25, name: 'São Paulo',     stateCode: 'SP',  countryCode: 'BR' },
  { id: 26, name: 'Campinas',      stateCode: 'SP',  countryCode: 'BR' },
  { id: 27, name: 'Rio de Janeiro', stateCode: 'RJ', countryCode: 'BR' },
  { id: 28, name: 'Buenos Aires',  stateCode: 'BA',  countryCode: 'AR' },
  { id: 29, name: 'Bogotá',        stateCode: 'CUN', countryCode: 'CO' },
  { id: 30, name: 'Medellín',      stateCode: 'ANT', countryCode: 'CO' },
  { id: 31, name: 'Santiago',      stateCode: 'RM',  countryCode: 'CL' },
  { id: 40, name: 'Munich',        stateCode: 'BY',  countryCode: 'DE' },
  { id: 41, name: 'Berlin',        stateCode: 'BE',  countryCode: 'DE' },
  { id: 42, name: 'Cologne',       stateCode: 'NW',  countryCode: 'DE' },
  { id: 43, name: 'Düsseldorf',    stateCode: 'NW',  countryCode: 'DE' },
  { id: 44, name: 'Hamburg',       stateCode: 'HH',  countryCode: 'DE' },
  { id: 45, name: 'Paris',         stateCode: 'IDF', countryCode: 'FR' },
  { id: 46, name: 'Marseille',     stateCode: 'PAC', countryCode: 'FR' },
  { id: 47, name: 'Lyon',          stateCode: 'ARA', countryCode: 'FR' },
  { id: 48, name: 'Lagos',         stateCode: 'LA',  countryCode: 'NG' },
  { id: 49, name: 'Abuja',         stateCode: 'AB',  countryCode: 'NG' },
  { id: 57, name: 'Johannesburg',  stateCode: 'GP',  countryCode: 'ZA' },
  { id: 58, name: 'Cape Town',     stateCode: 'WC',  countryCode: 'ZA' },
  { id: 59, name: 'Cairo',         stateCode: 'CAI', countryCode: 'EG' },
  { id: 60, name: 'Nairobi',       stateCode: 'NBO', countryCode: 'KE' },
  { id: 64, name: 'Milan',         stateCode: 'LOM', countryCode: 'IT' },
  { id: 65, name: 'Rome',          stateCode: 'LAZ', countryCode: 'IT' },
  { id: 66, name: 'Madrid',        stateCode: 'MAD', countryCode: 'ES' },
  { id: 67, name: 'Barcelona',     stateCode: 'CAT', countryCode: 'ES' },
  { id: 71, name: 'Istanbul',      stateCode: 'IST', countryCode: 'TR' },
  { id: 72, name: 'Ankara',        stateCode: 'ANK', countryCode: 'TR' },
];

/* ── Region grouping (Nick requested region-level breakdown) ── */
export interface GeoRegion { code: string; name: string; countries: string[]; }

export const GEO_REGIONS: GeoRegion[] = [
  { code: 'NA',  name: 'North America',  countries: ['US', 'CA', 'MX'] },
  { code: 'EU',  name: 'Europe',         countries: ['GB', 'DE', 'FR', 'IT', 'ES', 'TR'] },
  { code: 'ME',  name: 'Middle East',    countries: ['AE', 'SA'] },
  { code: 'AF',  name: 'Africa',         countries: ['NG', 'ZA', 'EG', 'KE'] },
  { code: 'OC',  name: 'Oceania',        countries: ['AU'] },
  { code: 'LA',  name: 'South America',  countries: ['BR', 'AR', 'CO', 'CL'] },
];

export function getStatesForCountry(countryCode: string): GeoState[] {
  return GEO_STATES.filter(s => s.countryCode === countryCode);
}

export function getCitiesForState(countryCode: string, stateCode: string): GeoCity[] {
  return GEO_CITIES.filter(c => c.countryCode === countryCode && c.stateCode === stateCode);
}

export function getCountriesForRegion(regionCode: string): GeoCountry[] {
  const region = GEO_REGIONS.find(r => r.code === regionCode);
  return region ? GEO_COUNTRIES.filter(c => region.countries.includes(c.code)) : [];
}
